import React from 'react'
import { Icon } from '@iconify/react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logout } from '../../containers/auth-container/reducer/authSlice'

const UserDropdown = ({
  user = {
    name: 'User',
    role: 'Admin',
    avatar: '/assets/images/user/user-16.jpg',
  },
  menuItems = [
    { label: 'Log Out', icon: 'lucide:power', href: '/', danger: true },
  ],
  onClose = () => { },
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleLogout = (e) => {
    e.preventDefault()
    localStorage.clear()

    dispatch(logout())
    navigate('/login')
    onClose()
  }

  return (
    <div className="dropdown">
      <button
        className="d-flex justify-content-center align-items-center rounded-circle"
        type="button"
        data-bs-toggle="dropdown"
      >
        <img
          src={user.avatar}
          alt="User"
          className="w-40-px h-40-px object-fit-cover rounded-circle"
        />
      </button>
      <div className="dropdown-menu to-top dropdown-menu-sm">
        <div className="py-12 px-16 radius-8 bg-primary-500 mb-16 d-flex align-items-center justify-content-between gap-2">
          <div>
            <h6 className="text-lg text-white fw-semibold mb-2">
              {user.name}
            </h6>
            <span className="text-white fw-medium text-sm">
              {user.role}
            </span>
          </div>
          <button type="button" className="text-white hover-text-white:hover" onClick={onClose}>
            <Icon icon="radix-icons:cross-1" className="icon text-xl" />
          </button>
        </div>
        <ul className="to-top-list">
          {menuItems.map((item, index) => (
            <li key={index}>
              {item.label === 'Log Out' ? (
                <a
                  href="/"
                  className={`dropdown-item text-black px-0 py-8 hover-bg-transparent ${item.danger ? 'hover-text-primary' : 'hover-text-primary'
                    } d-flex align-items-center gap-3`}
                  onClick={handleLogout}
                >
                  <Icon icon={item.icon} className="icon text-xl" />
                  {item.label}
                </a>
              ) : (
                <a
                  href={item.href}
                  className={`dropdown-item text-black px-0 py-8 hover-bg-transparent ${item.danger ? 'hover-text-primary' : 'hover-text-primary'
                    } d-flex align-items-center gap-3`}
                >
                  <Icon icon={item.icon} className="icon text-xl" />
                  {item.label}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default UserDropdown
